<template>
    <!-- PRODUCT -->
    <div class="md-layout-item md-size-100">
        <md-card class="pl-1 pr-1">
            <md-card-header class="pb-0">
                <h4 class="title pt-1" v-if="!productLoading">
                    {{ product.name }}
                </h4>
            </md-card-header>
            <md-card-content class="pb-2">
                <div class="md-layout" v-if="!productLoading">
                    <div
                        class="md-layout-item md-size-10 md-large-size-10 md-medium-size-20 md-small-size-30 md-xsmall-size-100 image-content"
                    >
                        <i
                            v-if="!product.image_url"
                            class="far fa-times-circle"
                            style="font-size: 120px"
                        ></i>
                        <md-content v-else class="md-elevation-1">
                            <img v-bind:src="product.image_url" />
                        </md-content>
                    </div>
                    <div
                        class="md-layout-item md-layout md-alignment-top-left list-content"
                    >
                        <div
                            class="md-layout-item md-size-33 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                        >
                            <b>Código:</b>
                            <span class="item-content">{{
                                product.external_common_id
                            }}</span>
                        </div>
                        <div
                            class="md-layout-item md-size-33 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                        >
                            <b>Descrição:</b>
                            <span class="item-content">{{ product.name }}</span>
                        </div>
                        <div
                            class="md-layout-item md-size-33 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                        >
                            <b>Referência:</b>
                            <span class="item-content">{{
                                product.reference_number
                            }}</span>
                        </div>
                        <div
                            class="md-layout-item md-size-33 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                        >
                            <b>Fornecedor:</b>
                            <span class="item-content">{{
                                product.brand
                            }}</span>
                        </div>
                        <div
                            class="md-layout-item md-size-33 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                        >
                            <b>Status:</b>
                            <span class="item-content">{{
                                statusNames[product.status]
                            }}</span>
                        </div>
                        <div
                            class="md-layout-item md-size-33 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                        >
                            <b>Cor:</b>
                            <span class="item-content">{{
                                product.color && product.color.name
                                    ? product.color.name
                                    : 'SEM COR'
                            }}</span>
                        </div>
                        <div
                            class="md-layout-item md-size-33 md-small-size-100 md-medium-size-50 md-alignment-top-space-between"
                        >
                            <b>Voltagem:</b>
                            <span class="item-content">{{
                                product.voltage && product.voltage != '0'
                                    ? product.voltage
                                    : 'SEM VOLTAGEM'
                            }}</span>
                        </div>
                    </div>
                </div>

                <div class="text-center mt--2 pb-2" v-else>
                    <img src="loader.svg" style="width: 100px; height: 100px" />
                </div>
            </md-card-content>
        </md-card>
    </div>
</template>

<script>
export default {
    props: ['productLoading', 'product'],
    data() {
        return {
            statusNames: {
                P: 'Candidato',
                A: 'Ativo',
                D: 'Em descontinuação',
                O: 'Descontinuado',
                I: 'Inativo'
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.list-content {
    .item-content {
        float: right;
    }
}

.image-content {
    text-align: center;
    min-width: 200px;
}
</style>
